"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FakeLoadingBar = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactTransitionGroup = require("react-transition-group");
var _fakeLoadingBarModule = _interopRequireDefault(require("././fakeLoadingBar.module.scss"));
var _this = void 0;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FakeLoadingBar = exports.FakeLoadingBar = function FakeLoadingBar(props) {
  var loadingBar = /*#__PURE__*/_react["default"].createRef();
  var loadingCompleteEvent = new CustomEvent("loadingComplete");
  var transitionStyles = {
    entering: {
      width: "96%"
    },
    entered: {
      width: "96%"
    },
    exiting: {
      transition: "width 0.5s ease-out, opacity 0.5s cubic-bezier(.99,.05,.74,1.04)",
      width: "100%",
      opacity: 0
    },
    exited: {
      transition: "width 0s ease-out",
      width: 0,
      opacity: 1
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.Transition, {
    "in": props.loading,
    appear: true,
    timeout: {
      appear: 10000,
      enter: 10000,
      exit: 500
    },
    nodeRef: loadingBar,
    onExited: window.dispatchEvent.bind(_this, loadingCompleteEvent)
  }, function (state) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "fake-loading-bar",
      "data-state": state,
      ref: loadingBar,
      className: "".concat(_fakeLoadingBarModule["default"].loading, " ").concat(_fakeLoadingBarModule["default"][state])
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _fakeLoadingBarModule["default"].inner,
      style: _objectSpread({}, transitionStyles[state])
    }, " "));
  });
};
FakeLoadingBar.propTypes = {
  loading: _propTypes["default"].bool
};
FakeLoadingBar.defaultProps = {
  loading: false
};
var _default = exports["default"] = FakeLoadingBar;